import { render, staticRenderFns } from "./Nps.vue?vue&type=template&id=9b08669e&"
import script from "./Nps.vue?vue&type=script&lang=js&"
export * from "./Nps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports